import { CommandType } from "../../../../common/services/cqs/CommandType";
import { AtgardBaseCommand } from "./AtgardBaseCommand";

export class SlutjusteraAtgardCommand extends AtgardBaseCommand {
    atgardGuid: string;
    static readonly $type = "SlutjusteraAtgardCommand";

    constructor(atgardGuid: string) {
        super(SlutjusteraAtgardCommand.$type, CommandType.Replace);
        this.atgardGuid = atgardGuid;
    }
}
